export default __webpack_public_path__ + "static/media/BackgroundLandingPage.9e733db6.jpg";